import React from 'react';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'default' | 'small' | 'none';
  id?: string;
}

const Section: React.FC<SectionProps> = ({
  children,
  className = '',
  padding = 'default',
  id,
}) => {
  const paddingClass =
    padding === 'default'
      ? 'section-padding'
      : padding === 'small'
      ? 'section-padding-sm'
      : '';

  return (
    <section
      id={id}
      className={`relative grain-background ${paddingClass} ${className}`}
    >
      <div className="container-custom relative" style={{ zIndex: 30 }}>{children}</div>
    </section>
  );
};

export default Section;
